import { getRequirementId, isRequirementRef, toRequirementRef } from '../../../../../util/directoryRoleRequirement.util'
import { isRoleInput } from '../../policy_feature/inputs'
import useNameFieldRequirements, {
  buildNameRequirementOptionsMap,
  getAutoModeNameInputs,
} from '../NameRequirements/useNameFieldRequirements'

// Built-in role template ids are not refs, so editing the attached requirements keeps any
// built-in ids already on the field.
const ROLE_REFS = { isInput: isRoleInput, isRequirementRef, getRequirementId, toRequirementRef }

export const getAutoModeRoleInputs = (policyBody) => getAutoModeNameInputs(policyBody, ROLE_REFS)

export const buildDirectoryRoleRequirementOptionsMap = (values) => buildNameRequirementOptionsMap(values, ROLE_REFS)

export default function useRoleFieldRequirements({ initialPolicyBody, setPolicyBody }) {
  return useNameFieldRequirements({ initialPolicyBody, setPolicyBody, refs: ROLE_REFS })
}
